import { useEffect } from "react";

const BASE_TITLE = "Platforms · Developer Platforms by BoldBrave + Logikfabriken";

function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

// Lightweight per-route document title + description for an SPA.
export function useDocumentMeta(title: string, description?: string) {
  useEffect(() => {
    document.title = title ? `${title} · Platforms` : BASE_TITLE;
    if (description) {
      setMeta("description", description);
    }
  }, [title, description]);
}
